function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{opacity:0.4;fill:#FFFFFF;enable-background:new    ;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Path_805_1_",
  className: "st0",
  d: "M11.3,13.5v11.4c0,0.6,0.5,1.1,1.1,1.1H16c0.6,0,1.1-0.5,1.1-1.1v-7.7h7.7 c0.6,0,1.1-0.5,1.1-1.1v-3.7c0-0.6-0.5-1.1-1.1-1.1H13.5C12.2,11.3,11.3,12.3,11.3,13.5L11.3,13.5z"
});

var SvgExpandLightSolid = function SvgExpandLightSolid(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "R\\xE9teg_1",
    focusable: "false",
    x: "0px",
    y: "0px",
    viewBox: "0 0 48.7 48.7",
    style: {
      enableBackground: "new 0 0 48.7 48.7"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgExpandLightSolid, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/expand-light-solid.20e2a5e8.svg";
export { ForwardRef as ReactComponent };